export default __webpack_public_path__ + "static/thumbnail-2-b2a185afe4cb55626a1112b02498d44e.png";